var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVarsomeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-43.454 117.603 843.454 228.8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("rect", {
    x: -14.6,
    y: -16.5,
    className: "st0",
    width: 844,
    height: 228.8,
    transform: "matrix(1, 0, 0, 1, -28.853597, 134.103282)",
    style: {
      fill: "transparent"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000104699885163355431900000005643321794964445339_",
    transform: "matrix(1, 0, 0, 1, -28.853597, 134.103282)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000114780835952534692400000004275190547000158603_",
    transform: "matrix(1, 0, 0, 1, -28.853597, 134.103282)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 46)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,28.7c1.9-0.8,7.7-2.6,11.1,5.8c1.1,2.8,2.2,5.6,3.4,8.5c1.9,4.5,3.7,8.8,5.6,12.9s3.6,7.7,5.2,11 c1.6,3.3,2.9,6,4,8.2c1.6-2.9,3.2-6.4,5-10.4c1.8-4,3.5-8,5.2-11.9c1.7-3.9,3.2-7.5,4.5-10.7c1.3-3.2,2.3-5.6,2.9-7.1 c0.8-2,1.8-3.7,2.9-4.8c1.1-1.2,2.9-1.8,5.4-1.8c0,0,9.7,0.5,4.3,12.6c-1,2.2-1.9,4.5-3.1,7.1c-1.7,3.7-3.5,7.5-5.4,11.5 c-1.9,4-3.8,7.9-5.7,11.7c-1.9,3.8-3.7,7.3-5.3,10.6c-1.7,3.3-3.1,6-4.2,8.1h-13.7c-3.8-7.1-7.4-13.8-10.5-20.1 c-3.2-6.3-5.9-11.8-8.2-16.7c-2.3-4.9-3.9-9-5.3-12.3C293.9,30.8,300.2,28.7,300.2,28.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.3,32.3c0.6-1.1,1.7-2.1,3.3-2.9c1.6-0.9,3.6-1.5,6.3-2c2.6-0.5,5.9-0.7,9.9-0.7c4.8,0,9.2,0.5,13.2,1.4 c4,0.9,7.4,2.4,10.2,4.5c2.9,2,5.1,4.7,6.7,8.1c1.6,3.4,2.4,7.4,2.4,12.1v36.9c-0.8,0.2-2.1,0.3-3.9,0.6 c-1.8,0.2-3.8,0.4-6.2,0.6c-2.4,0.2-5,0.4-8,0.6c-2.9,0.2-6,0.2-9.2,0.2c-6.4,0-11.6-0.6-15.6-1.7c-4-1.1-7.2-2.6-9.6-4.4 c-2.3-1.8-3.9-4-4.8-6.4c-0.9-2.4-1.3-4.9-1.3-7.4c0-3.4,0.5-6.3,1.5-8.8c1-2.5,2.7-4.7,5-6.4c2.3-1.7,5.4-3,9.1-3.9 c3.8-0.9,8.3-1.3,13.7-1.3c3.1,0,6.1,0.1,8.8,0.3c2.8,0.2,4.9,0.4,6.3,0.6c0-2.9-0.5-5.2-1.4-7.1c-0.9-1.9-2.2-3.4-3.9-4.4 c-1.6-1.1-3.6-1.8-5.9-2.2c-2.3-0.4-4.8-0.6-7.6-0.6c-4.7,0-8.4,0.6-11.2,1.6c-2.5,0.9-4.6,0.8-5.9,0.1 C372.7,37.5,375.3,32.3,375.3,32.3z M413.4,62.5c-0.8-0.2-2.4-0.4-4.6-0.7c-2.2-0.3-5.6-0.5-10.1-0.5c-5.6,0-9.6,0.8-12.1,2.5 c-2.5,1.7-3.8,4.3-3.8,7.9c0,1.5,0.3,2.8,0.8,4c0.5,1.2,1.5,2.3,2.8,3.1c1.3,0.9,3.1,1.5,5.3,2c2.2,0.5,5,0.7,8.4,0.7 c3.8,0,6.7-0.1,9-0.4c2.2-0.3,3.7-0.5,4.4-0.7L413.4,62.5L413.4,62.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.7,39.7c-1.7-0.3-3.5-0.5-5.6-0.5c-9.6,0-14.4,5.1-14.4,15.2v35.6h-14V50.3c0-7.5,2.3-13.4,6.9-17.5 c4.6-4.1,11-6.2,19.2-6.2c5.2,0,9.3,0.7,12.6,2.1c3.2,1.4,4.8,3.6,4.8,6.6c0,0.5,0,1-0.1,1.5C484.9,41.8,476.7,39.7,476.7,39.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M538.4,40.1c-0.3-0.1-0.5-0.2-0.8-0.3c-1.9-0.7-4.1-1.3-6.7-1.8c-2.6-0.5-5.6-0.8-9.1-0.8 c-9.5,0-14.2,2.5-14.2,7.5c0,2.1,0.9,3.7,2.7,4.8c1.8,1.1,4.4,1.9,7.7,2.3l12.5,1.6c6.8,0.9,12.1,2.8,15.8,5.6 c3.8,2.8,5.6,7,5.6,12.4c0,6.1-2.4,11-7.3,14.7s-11.9,5.5-21,5.5c-4.4,0-8.4-0.3-12-1C508,90,505,89.4,501,88.1 c-2.6-0.9-4.8-2-6.4-2.8c-1.6-0.8-2.7-1.4-3.2-1.8l5.3-9.4c0.6,0.4,1.6,0.9,3.1,1.6c1.5,0.7,4.5,1.9,6.6,2.6 c2.2,0.7,4.6,1.3,7.4,1.8c2.8,0.5,5.8,0.7,9.1,0.7c4.3,0,7.7-0.6,10.4-1.7c2.7-1.1,4-3,4-5.7c0-2.3-0.9-4-2.6-5.2 c-1.7-1.2-4.8-2-9.2-2.5l-9.6-1.1c-3.3-0.3-6.3-0.9-9-1.8s-5.1-2-7.1-3.5s-3.5-3.3-4.6-5.5c-1.1-2.2-1.7-4.8-1.7-7.8 c0-2.6,0.5-5.1,1.5-7.4c1-2.3,2.6-4.4,4.8-6.2c2.2-1.8,5.1-3.2,8.6-4.2c3.6-1,7.9-1.5,12.9-1.5c8.5,0,15.1,0.9,19.8,2.8 s7.1,4.3,7.1,7.4c0,1-0.2,1.8-0.6,2.6C545.7,43.9,538.4,40.1,538.4,40.1z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.7,26.6c4.7,0,9.2,0.8,13.3,2.5c4.1,1.6,7.7,3.9,10.7,6.8c3,2.9,5.4,6.3,7.1,10.3 c1.7,4,2.6,8.3,2.6,12.9c0,4.6-0.9,8.9-2.6,12.8c-1.7,4-4.1,7.4-7.1,10.3c-3,2.9-6.6,5.2-10.7,6.9c-4.1,1.7-8.6,2.5-13.3,2.5 c-4.7,0-9.2-0.8-13.3-2.5c-4.1-1.7-7.7-4-10.7-6.9c-3-2.9-5.4-6.3-7.1-10.3c-1.7-4-2.6-8.2-2.6-12.8c0-4.7,0.9-9,2.6-12.9 c1.7-4,4.1-7.4,7.1-10.3c3-2.9,6.6-5.2,10.7-6.8C584.5,27.5,588.9,26.6,593.7,26.6z M593.7,79.3c2.8,0,5.4-0.5,7.7-1.5 c2.4-1,4.4-2.5,6.1-4.3c1.7-1.8,3-4,3.9-6.4c0.9-2.4,1.4-5,1.4-7.9c0-2.9-0.5-5.5-1.4-8c-0.9-2.5-2.2-4.6-3.9-6.4 c-1.7-1.8-3.7-3.2-6.1-4.2c-2.4-1-4.9-1.5-7.7-1.5c-2.9,0-5.5,0.5-7.8,1.5c-2.3,1-4.3,2.4-6,4.2s-3,3.9-3.9,6.4 c-0.9,2.5-1.4,5.2-1.4,8c0,2.9,0.5,5.5,1.4,7.9c0.9,2.4,2.2,4.5,3.9,6.4s3.7,3.3,6,4.3C588.2,78.8,590.8,79.3,593.7,79.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M638,50.3c0-3.9,0.7-7.4,2.1-10.3c1.4-2.9,3.3-5.4,5.7-7.4c2.4-2,5.3-3.5,8.5-4.5c3.3-1,6.8-1.5,10.7-1.5 c5.1,0,9.6,0.9,13.6,2.8c4,1.9,7.2,4.7,9.6,8.3c2.4-3.7,5.5-6.5,9.4-8.3c3.9-1.9,8.4-2.8,13.4-2.8c3.8,0,7.3,0.5,10.5,1.5 c3.3,1,6.1,2.5,8.5,4.4c2.4,2,4.3,4.4,5.6,7.4c1.4,2.9,2.1,6.4,2.1,10.3v39.7h-14V55c0-5.6-1.3-9.7-3.8-12.1 c-2.5-2.4-6-3.6-10.3-3.6c-4.2,0-7.7,1.3-10.5,4c-2.8,2.7-4.2,7.1-4.2,13.1v33.5h-14V56.5c0-6.1-1.4-10.4-4.2-13.1 c-2.8-2.7-6.3-4-10.5-4c-4.3,0-7.7,1.2-10.3,3.7s-3.9,6.5-3.9,12.1v34.8h-14L638,50.3L638,50.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M805.5,85.4c-0.7,0.4-1.7,1-3.1,1.7c-1.4,0.7-3.1,1.4-5.2,2.1c-2.1,0.7-4.5,1.2-7.2,1.7 c-2.7,0.5-5.7,0.7-9,0.7c-4.6,0-8.9-0.7-12.8-2.1c-4-1.4-7.4-3.5-10.4-6.2c-3-2.7-5.3-6.1-7.1-10.1c-1.7-4-2.6-8.5-2.6-13.7 c0-4.9,0.8-9.4,2.5-13.4c1.7-4,4-7.5,7-10.4c3-2.9,6.5-5.2,10.5-6.7c4-1.6,8.5-2.4,13.3-2.4c4.2,0,8,0.6,11.3,1.7 c3.3,1.1,6,2.6,8.3,4.4c2.2,1.8,3.9,4,5.1,6.4c1.1,2.5,1.7,5.1,1.7,7.9c0,2.9-0.5,5.5-1.6,7.8c-1.1,2.3-2.9,4.3-5.6,6 c-2.7,1.7-6.3,3-10.9,3.9c-4.6,0.9-10.4,1.4-17.4,1.4c-1.6,0-3.2,0-4.6-0.1c-1.4,0-3-0.1-4.6-0.2c0.7,4.2,2.7,7.5,6.1,10.1 c3.4,2.6,8.2,3.9,14.5,3.9c2.1,0,4.1-0.2,5.9-0.5c1.8-0.3,3.4-0.7,4.8-1.2c1.4-0.5,2.7-1,3.7-1.5c1-0.5,1.8-0.9,2.3-1.1 L805.5,85.4z M762.5,56.3c1.9,0.1,3.7,0.1,5.4,0.1c1.7,0,3.4,0,5.2,0c4.5,0,8.1-0.3,10.9-0.9c2.8-0.6,4.9-1.3,6.5-2.2 c1.6-0.9,2.6-1.9,3.1-3.1c0.5-1.1,0.7-2.3,0.7-3.6c0-3.1-1.2-5.4-3.7-7c-2.5-1.6-5.6-2.3-9.3-2.3c-3,0-5.7,0.5-8,1.6 c-2.3,1.1-4.2,2.5-5.8,4.2c-1.6,1.8-2.8,3.8-3.6,6.1C763,51.6,762.5,54,762.5,56.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.982655, 0, 0, 0.982655, 4.460482, -0.722229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.3,52.9c-0.8-0.9-1.6-1.8-2.4-2.7c-16.1-16.1-42.2-16.1-58.4,0c-15.8,15.7-16.1,41.1-1.1,57.2 c-0.1,0-0.2,0-0.2,0.1l30.3,30.3c5.4,5.4,14.4,5.4,19.8,0l38.6-38.6l9.9-9.9L73.3,52.9z",
    style: {
      fill: "rgb(249, 201, 0)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.6346,
    y1: 5445.7734,
    x2: 0.1376,
    y2: 5366.0332,
    gradientTransform: "matrix(1 0 0 1 26.3409 -5322.9199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F96C1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    style: {
      stopColor: "#F5822B",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.3,52.9c-0.8-0.9-1.6-1.8-2.4-2.7c-16.1-16.1-42.2-16.1-58.4,0c-15.8,15.7-16.1,41.1-1.1,57.2 c-0.1,0-0.2,0-0.2,0.1l30.3,30.3c5.4,5.4,14.4,5.4,19.8,0l38.6-38.6l9.9-9.9L73.3,52.9z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179621077304438222440000008103867135622829184_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.7649,
    y1: 5475.0605,
    x2: 48.5838,
    y2: 5427.4961,
    gradientTransform: "matrix(1 0 0 1 0 -5352.0005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#840B3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1259,
    style: {
      stopColor: "#840B3C",
      stopOpacity: 0.8741
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#840B3C",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000179621077304438222440000008103867135622829184_)",
      enableBackground: "new"
    },
    d: " M73.3,52.9c-0.2-0.2-0.3-0.4-0.5-0.6c-11.5,11.1-24,21.1-35.7,31.9c-8.5,7.9-16.2,16.6-24.8,24.3l29.2,29.2 c5.4,5.4,14.4,5.4,19.8,0l38.6-38.6l9.9-9.9L73.3,52.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033355893484795864100000015975432269764698554_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.6038,
    y1: 5323.9033,
    x2: 40.1907,
    y2: 5484.7832,
    gradientTransform: "matrix(1 0 0 1 26.3409 -5322.9199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88D835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0893,
    style: {
      stopColor: "#7AD741"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    style: {
      stopColor: "#38D277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    style: {
      stopColor: "#10CF99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CEA6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033355893484795864100000015975432269764698554_)"
    },
    d: "M245.1,12.3 c-16.1-16.1-42.2-16.1-58.4,0l0,0l-0.1-0.1l-18.6,18.7l-58.4,58.4l-29.2,29.2c-16.1,16.1-42.2,16.1-58.4,0l58.4,58.4 c16.1,16.1,42.2,16.1,58.4,0l29.2-29.2l52.4-52.4l0,0l9.9-9.9l14.7-14.7c0,0,0,0,0,0C261.2,54.6,261.2,28.4,245.1,12.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026164538700389854460000013746138845023166339_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.8114,
    y1: 5487.2798,
    x2: 74.3862,
    y2: 5448.1094,
    gradientTransform: "matrix(1 0 0 1 26.3409 -5322.9199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02BC87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8918,
    style: {
      stopColor: "#02BC87",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026164538700389854460000013746138845023166339_)"
    },
    d: "M127.1,142.7 c-9.7-7.8-15-11.8-24.8-19.5c-4.1-3.2-8.3-6.4-11.9-10.2c-0.7-0.8-1.4-1.5-2.1-2.3l-7.7,7.7c-16.1,16.1-42.2,16.1-58.4,0 l58.4,58.4c16.1,16.1,42.2,16.1,58.4,0l13.6-13.6C144,156.4,135.6,149.5,127.1,142.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076595321177228602510000010470243145427851961_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.494,
    y1: -238.5162,
    x2: 494.3073,
    y2: -207.5695,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 -276.6769 -166.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7736,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000076595321177228602510000010470243145427851961_)",
      enableBackground: "new"
    },
    d: " M200.8,20c15,12.2,28.7,25.8,41.4,40.3c3.7-3.9,6.4-8.7,7.8-14c3.3-11.6,0.1-24-8.3-32.4c-4.1-4.1-9.1-7-14.7-8.5 C215.3,2.3,203.2,6,194.9,14C196.9,16,198.9,18,200.8,20z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102503138687768260470000011355779307589214907_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.8313,
    y1: 5393.0303,
    x2: 39.6447,
    y2: 5423.9771,
    gradientTransform: "matrix(1 0 0 1 0 -5352.0005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7736,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000102503138687768260470000011355779307589214907_)",
      enableBackground: "new"
    },
    d: " M15.1,74c19.2-2,38.5-2,57.8-0.7c-0.2-5.4-1.6-10.6-4.3-15.4c-5.9-10.5-16.9-17-28.8-17c-5.7,0-11.4,1.5-16.4,4.4 C12.8,51.3,6.9,62.4,6.7,73.9C9.5,73.9,12.3,74,15.1,74z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarsomeLogo);
export default __webpack_public_path__ + "static/media/varsome_logo.e6e92e0f1214b681e111fa08336b8e57.svg";
export { ForwardRef as ReactComponent };